import { Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MiddleCard from "../../components/cards/MiddleCard";
import { useApi } from "../../contexts/ApiContext";
import { useApp } from "../../contexts/AppContext";

const EmailConfirmationCallback: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { apiService } = useApi();
  const [dots, setDots] = useState(".");

  const [error, setError] = useState("");

  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");
  const [verified, setVerified] = useState(false);

  const { translate } = useApp();
  const authTranslations = useMemo(() => translate("auth"), [translate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((dots) => (dots.length === 3 ? "." : dots + "."));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const usernameParam = queryParams.get("n");
    const codeParam = queryParams.get("c");

    if (usernameParam) setUsername(usernameParam);
    if (codeParam) setCode(codeParam);
  }, [location.search]);

  const validate = () => {
    return code.length && username.length;
  };

  const verifyCode = async () => {
    if (!validate()) {
      return;
    }

    try {
      const response = await apiService.get<{ confirmed: boolean }>(
        `/user/verify?n=${username}&c=${code}`
      );
      if (!response.confirmed) {
        setError(authTranslations.errors.invalid_verification_code);
      }
    } catch (error) {
      setError(authTranslations.errors.verficiation_general_error);
    } finally {
      setCode("");
      setVerified(true);
      setTimeout(() => {
        navigate("/");
      }, 3000);
    }
  };

  useEffect(() => {
    verifyCode();
  }, [username, code]);

  if (verified) {
    return (
      <MiddleCard title={authTranslations.email_verification.success}>
        <Typography variant="h6" gutterBottom>
          {authTranslations.email_verification.success}
        </Typography>
        <Typography variant="body1" color="textSecondary" mb={3}>
          {authTranslations.email_verification.success_subtitle}
        </Typography>
      </MiddleCard>
    );
  }

  return (
    <MiddleCard sx={{ width: 240 }}>
      {error.length ? (
        <Typography variant="body1" color="error">
          {error}
        </Typography>
      ) : (
        `${authTranslations.email_verification.verifying} ${dots}`
      )}
    </MiddleCard>
  );
};

export default EmailConfirmationCallback;
